import React from 'react';
import ReactDOM from 'react-dom';
import CookieConsent from "react-cookie-consent";

import ContactForm from './contact/ContactForm';
import Gallery from './gallery/Gallery';
import Blog from './blog/Blog';


const galleryRef = document.getElementById('galleryRef');
const contactRef = document.getElementById('contactRef');
const blogRef = document.getElementById('blogRef');
const consentRef = document.getElementById('consentRef');

ReactDOM.render(<ContactForm />, contactRef);
ReactDOM.render(<Gallery />, galleryRef);
ReactDOM.render(<Blog />, blogRef);
ReactDOM.render(<CookieConsent
    buttonText="Rozumiem"
  >
    Ta strona używa ciasteczek w celach statystycznych. Kontynuując przeglądanie strony wyrażasz zgodę na ich wykorzystanie.
  </CookieConsent>, consentRef);


// WEBPACK FOOTER //
// ./src/index.js